import { getFetch } from '../fetch';
import { apiConfig } from '../config';
import { TeacherProfile } from '../../../typings';

export function getTeacherProfile(): Promise<TeacherProfile> {
    const { apiGetTeacherProfile } = apiConfig.getStaticUrls();

    return getFetch(apiGetTeacherProfile);
}
